/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import store from "@/store";
import { constants } from "@/shared/constants";

const downloadFile = function(response) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.style.display = "none";
  let filename = response.headers["content-disposition"].split('"')[1];
  if (filename === undefined) {
    filename = response.headers["content-disposition"].split("=")[1];
  }
  link.setAttribute("download", filename);
  // This allows to download files in safari if pop up blocking is enabled.
  if (typeof link.download === "undefined") {
    link.setAttribute("target", "_blank");
  }
  document.body.appendChild(link);
  link.click();
};

const viewFile = function(response) {
  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
};
const fakeAPI = function(ms) {
  return Promise.resolve().then(
    () => new Promise(resolve => setTimeout(() => resolve(), ms))
  );
};

const hasRoutingHistory = function() {
  const _minHistoryLength = 2;
  return window.history.length > _minHistoryLength;
};

const allowedComponent = function() {
  const map = new Map();
  const currentUser = store.getters["account/getCurrentUser"];
  if (currentUser.admin) {
    constants.ROLE_PERMISSIONS.forEach(element => {
      map.set(element, true);
    });
  } else {
    constants.ROLE_PERMISSIONS.forEach(element => {
      map.set(element, false);
    });
    const permissions = currentUser?.role?.permissions || [];
    permissions.forEach(element => {
      map.set(element.name, true);
    });
  }
  return map;
};

const isVIEWER = function() {
  const currentUser = store.getters["account/getCurrentUser"];
  return currentUser.role?.roleType === constants.ROLE_TYPE.VIEWER;
};

const isAnyOfUserTypes = function() {
  const currentUser = store.getters["account/getCurrentUser"];
  return (
    currentUser.clientType === constants.USER_TYPE.B2B2B ||
    currentUser.clientType === constants.USER_TYPE.B2B ||
    currentUser.clientType === constants.USER_TYPE.ARTISAN ||
    currentUser.clientType === constants.USER_TYPE.BAILLEUR_SOCIAL
  );
};

const isAnArtisan = function() {
  const currentUser = store.getters["account/getCurrentUser"];
  return currentUser.clientType === constants.USER_TYPE.ARTISAN;
};

const isNotB2B2B = function() {
  const currentUser = store.getters["account/getCurrentUser"];
  return currentUser.clientType !== constants.USER_TYPE.B2B2B;
};

const isUserOfType = function(types) {
  const currentUser = store.getters["account/getCurrentUser"];
  return types.includes(currentUser.clientType);
};

export const helpers = {
  downloadFile,
  viewFile,
  fakeAPI,
  hasRoutingHistory,
  allowedComponent,
  isVIEWER,
  isAnyOfUserTypes,
  isNotB2B2B,
  isAnArtisan,
  isUserOfType
};
